import { get, patch, post } from "./client";
import { ApiEndpoint, ApiSubresourceEndpoint } from "./endpoints";
import { store } from "../store";
import { updateOccupiedDays } from "../actions/store/app-actions";
import { getUnixTimestamp } from "../util/date-utility";
import { dispatchSubresourceRequest, Method } from "./dispatcher";

export interface OccupiedDay {
	id: string;
	date: Date;
	assignedReservations: number;
	unassignedReservations: number;
	linkedTables: string[][];
	lockdown: boolean;
	lockedAreas: string[];
}

export const transformOccupiedDayResponse = <T extends Partial<OccupiedDay>>(
	data: T
): T => {
	if (typeof data.date === "string") {
		data.date = new Date(data.date);
	}

	return data;
};

export const getOccupiedDaysByRange = async (from: Date, to: Date) => {
	const r = (await get(ApiEndpoint.OccupiedDays, null, {
		from: getUnixTimestamp(from, true, true),
		to: getUnixTimestamp(to, true)
	})) as [OccupiedDay[]];

	return r[0].map(d => transformOccupiedDayResponse(d));
};

export const getOccupiedDayByDate = async (date: Date) => {
	const r = (await get(
		ApiEndpoint.OccupiedDays,
		getUnixTimestamp(date, true).toString()
	)) as OccupiedDay[];

	return r.map(d => transformOccupiedDayResponse(d))[0];
};

export const patchOccupiedDay = async (
	date: Date,
	updateData: Partial<OccupiedDay>
) => {
	const r = (await patch(
		ApiEndpoint.OccupiedDays,
		getUnixTimestamp(date, true).toString(),
		updateData
	)) as OccupiedDay;

	return transformOccupiedDayResponse(r);
};

export const postOccupiedDayNotifyArea = async (
	date: Date,
	areaId: string
) => {
	const r = await dispatchSubresourceRequest(
		ApiEndpoint.OccupiedDays,
		ApiSubresourceEndpoint.NotifyArea,
		Method.POST,
		getUnixTimestamp(date, true).toString(),
		null,
		{
			area: areaId
		}
	);

	return;
};
